import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/utilities/auth.service';

@Component({
  selector: 'app-email-alert',
  templateUrl: './email-alert.component.html',
  styleUrls: ['./email-alert.component.scss']
})
export class EmailAlertComponent {
  contacts:any[]=[]
  tmpContact:string=""
  tmpUpdate:string=""
  toogleNewEmailInput:boolean=false
  iseditModOn:boolean=false
  currentItem:any=null
  inputType:string="hidden"

  constructor(
    private authService:AuthService
  ){}
  ngOnInit(){
    this.authService.getAlertContacts().subscribe((res:any)=>{
      console.log("contacts",res)
      this.contacts=res
    })
  }
  add(item:string){
    if(this._isValidEmail(item)){
      this.authService.newAlertContact(item.trim()).subscribe((res:any)=>{
        console.log("contacts",res)
        this.contacts=res
        this.tmpContact=""
      })
    }
    else{
      console.log("invalid email",this.tmpContact)
    }
  }
  remove(item:any){
    this.currentItem=item
    let answer=confirm("are you sure ?")
    if(answer){
      this.authService.destroyAlertContact(item.id).subscribe((res:any)=>{
      console.log("contacts",res)
      this.contacts=res
      this.currentItem =null
    })
    }
  }

  edit(item:any){
    this.currentItem=item
    this.tmpUpdate=item.email
    this.iseditModOn=true
    this.inputType="email"
  }
  update(item:any){
    console.log("tmpUpdate",this.tmpUpdate,"oldValue",this.currentItem)
    if(this.currentItem.email!=this.tmpUpdate ){
      if( this._isValidEmail(this.tmpUpdate)){
        this.authService.updateAlertContact(item.id,this.tmpUpdate).subscribe((res:any)=>{
          this.contacts = res
          this.iseditModOn=false
          this.currentItem=null
          this.inputType="hidden"
          this.tmpUpdate=""
        })
      }else{
        console.log("invalid email",this.tmpUpdate)
      }
    }else{
      console.log("nothing changed")
        this.iseditModOn=false
        this.currentItem=null
        this.inputType="hidden"
        this.tmpUpdate=""
    }

  }
  _isValidEmail(email:string){
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return emailRegex.test(email);
  }
  
  
}
